import { render, staticRenderFns } from "./GlobalSports.vue?vue&type=template&id=6df0510d&scoped=true"
import script from "./GlobalSports.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSports.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSports.vue?vue&type=style&index=0&id=6df0510d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0510d",
  null
  
)

export default component.exports